import { TimePanelDndStore } from './schema/TimePanelDndStore';
import { createStore } from 'satcheljs';
import { createDropViewState } from 'owa-dnd';

let getStore = createStore<TimePanelDndStore>('timePanelDndStore', <TimePanelDndStore>{
    dropBoxDropViewState: createDropViewState(),
    upNextDropViewState: createDropViewState(),
    timePanelDropViewState: createDropViewState(),
    calendarTabDropViewState: createDropViewState(),
    tasksTabDropViewState: createDropViewState(),
    lastDragOverCalendarTab: null,
    lastDragOverTasksTab: null,
    lastDragOverUpNext: null,
    shouldShowHoverDayDrop: false,
    dayViewDropTimeMinuteOffset: null,
});

export default getStore;
